module.exports = __webpack_public_path__ + "3f009bdab9df27bf1e5711d2804dadc1.png";